import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

export const Pricing = () => {
  const [expanded, setExpanded] = useState(false);
  return (
    <>
      {expanded ? (
        <div className="offer-container">
          <div className="pricing__container">
            <div className="pricing__plan-container">
              <div className="pricing__plan-name">Net30 Business Suite (basic)</div>
              <div className="text-center">
                <span className="pricing__price">$55 </span>
                <span className="pricing__price-schedule">/ month</span>
              </div>
              <div className="pricing__price-schedule text-center">
                Monthly billing
                <br />
                <span>&nbsp;</span>
              </div>
              <ul>
                <li>AI-Powered Business Plan Creation</li>
                <li>Project Management Account (up to 8&nbsp;users)</li>
                <li>Monthly Business Development Consultations</li>
                <li>Growegy Basic AI (GPT-4o mini)</li>
                <li>Loyalty Benefits (starting month&nbsp;5)</li>
                <li>Business Credit Reporting</li>
                <li>Marketplace with Exclusive Offers</li>
              </ul>
            </div>
            <div className="pricing__plan-container">
              <div className="pricing__plan-name">Net30 Business Suite (basic)</div>
              <div className="text-center">
                <span className="pricing__price">$600 </span>
                <span className="pricing__price-schedule">/ year</span>
              </div>
              <div className="pricing__price-schedule text-center">
                Make 3 interest-free payments
                <br />
                (invoiced over 3&nbsp;months).
              </div>
              <ul>
                <li>AI-Powered Business Plan Creation</li>
                <li>Project Management Account (up to 8&nbsp;users)</li>
                <li>Monthly Business Development Consultations</li>
                <li>
                  Growegy <strong>Advanced&nbsp;AI (GPT-4o)</strong>
                </li>
                <li>
                  Loyalty Benefits <strong>(starting month&nbsp;1)</strong>
                </li>
                <li>Business Credit Reporting</li>
                <li>Marketplace with Exclusive Offers</li>
                <li>
                  Reports Higher Credit <strong>Extended for all 12&nbsp;months</strong>
                </li>
                <li>
                  Free Month of Access <strong>(12 for the price of&nbsp;11)</strong>
                </li>
                <li>
                  <strong>Enhanced Support</strong>
                </li>
              </ul>
            </div>
          </div>
          <div className="pricing__footer">
            <Button
              variant="light"
              className="pricing__hide-button"
              onClick={() => setExpanded(false)}
              data-test="upgrade-to-annual__hide-annual-plan-button"
            >
              Hide
            </Button>
          </div>
        </div>
      ) : (
        <div className="billing__banner">
          <div className="growegy-font14">Not sure which plan suits you best?</div>
          <Button
            variant="primary"
            className="button-apply"
            onClick={() => {
              setExpanded(true);
            }}
          >
            View plans and benefits
          </Button>
        </div>
      )}
    </>
  );
};
